/**
 * Контуры логотипа KODE вынесены из компонента, потому что их рисует ещё и
 * KodeWelcome (обводкой). Без общего источника обводка разойдётся с логотипом
 * при первой же правке любого из двух.
 */
export const KODE_VIEWBOX = "0 0 111 24";

export const KODE_PATHS = [
  // E — три горизонтальные полосы
  "M88.066 20.508h22.805v2.973H88.066zM88.066 10.545h22.805v2.973H88.066zM88.066.585h22.805v2.973H88.066z",
  // O — кольцо
  "M39.232 23.961c-6.624 0-11.993-5.355-11.993-11.961S32.609.039 39.232.039C45.856.039 51.225 5.394 51.225 12c-.006 6.603-5.372 11.954-11.993 11.961zm0-20.949c-4.984 0-9.024 4.03-9.024 9s4.04 9 9.024 9c4.984 0 9.024-4.03 9.024-9a8.988 8.988 0 0 0-2.639-6.372A9.037 9.037 0 0 0 39.232 3v.012z",
  // D — квадратная рамка
  "M77.462 3.438v17.019H60.397V3.438h17.065zM80.443.465H57.416V23.43h23.027V.465z",
  // K — стойка и шеврон
  "M.084.528h2.981v22.944H.084zM19.935 23.37L8.585 12.051 20.037.63l2.106 2.1-9.343 9.321 9.24 9.219z",
];
